import React from 'react';
import Step1AgentPrice from './Step1AgentPrice';
import Step2BasicInfo from './Step2BasicInfo';
import Step3Content from './Step3Content';
import Step4Media from './Step4Media';
import Step5Instructions from './Step5Instructions';
import Step6Playground from './Step6Playground';
import Step7Review from './Step7Review';

const StepContent = ({ 
  currentStep, 
  formData, 
  register, 
  setValue, 
  control,
  errors, 
  saving,
  trigger // Adicionar trigger
}) => {
  const stepProps = {
    formData,
    register,
    setValue,
    control,
    errors,
    saving,
    trigger, // Passar trigger para os steps
  };

  switch (currentStep) {
    case 1:
      return <Step1AgentPrice {...stepProps} />;
    case 2:
      return <Step2BasicInfo {...stepProps} />;
    case 3:
      return <Step3Content {...stepProps} />;
    case 4:
      return <Step4Media {...stepProps} />;
    case 5:
      return <Step5Instructions {...stepProps} />;
    case 6:
      return <Step6Playground {...stepProps} />;
    case 7:
      return <Step7Review {...stepProps} />;
    default:
      return null;
  }
};

export default StepContent;